import {
  FETCH_LOAD_PROJECT_BY_ORGANISATION_ID_REQUEST,
  FETCH_LOAD_PROJECT_BY_ORGANISATION_ID_SUCCESS,
  FETCH_LOAD_PROJECT_BY_ORGANISATION_ID_FALUIRE,
} from './loadAllProjectsBasedUponOrganisationTypes'

const initialState = {
  loading: false,
  allProjectBasedUponSelectedOrganisationID: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_PROJECT_BY_ORGANISATION_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_PROJECT_BY_ORGANISATION_ID_SUCCESS : return {
      ...state,
      allProjectBasedUponSelectedOrganisationID: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_PROJECT_BY_ORGANISATION_ID_FALUIRE : return {
      ...state,
      loading: false,
      allProjectBasedUponSelectedOrganisationID: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
